import styles from '../styles/LoginForm.module.scss';
import logo from '../assets/logo.png';
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { useLoginFormValidator } from '../components/login/customHooks/useLoginFormValidator';
import { TextBox } from '@progress/kendo-react-inputs';
import { eyeIcon, eyeSlashIcon } from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { loadingPanel } from '../components/LoadingPanel';



export const NewPassword = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const localizationService = useLocalization()
  const navigate = useNavigate()


  const [visible, setVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<any>('');
  const [error, setError] = useState<any>('');
  const [loading, setLoading] = useState(true);

  const [imageLogo, setImageLogo] = useState<any>(null);

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const { errors, validateFormResetPassword, onBlurFieldResetPassword, getFieldError } = useLoginFormValidator(form);

  const [searchParams] = useSearchParams();
  const token = searchParams.get("t");

  const getImageLogo = async () => {
    axios.get(`${SERVER_URL}/account/logo`)
      .then((res) => {
        const image = `data:image/png;base64, ${res?.data?.data.image}`
        setImageLogo(image);
      }).catch(() => {

      });
  }

  const keysToKeep = [
    `languageId`
  ];

  const clearLocalStorageExcept = (keysToKeep: any) => {
    const localStorageKeys = Object.keys(localStorage);

    localStorageKeys.forEach(key => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  }

  useEffect(() => {

    clearLocalStorageExcept(keysToKeep)

    getToken(token);
  }, [])



  const onUpdateField = (e: any) => {
    const field = e.target.name as keyof typeof errors;
    const nextFormState = {
      ...form,
      [field]: e.target.value,
    };
    setForm(nextFormState);
    if (errors[field].dirty)
      validateFormResetPassword({
        form: nextFormState,
        errors,
        field,
      });
  };

  const getToken = async (token: any) => {
    try {
      const response = await axios.get(`${SERVER_URL}/account/by-token/${token}`);
      setError('');
    } catch (error: any) {
      //console.error("Errore durante il recupero del token:", error);
      if (axios.isAxiosError(error)) {
        setError(error.response?.data?.errorMessage || "Server error");
      } else {
        setError("Unknokwn error");
      }
    }finally {
      setLoading(false); 
    }
  };


  const resetPassword = () => {

    const payload: any = {
      token: token,
      password: form.password
    }

    axios.post(`${SERVER_URL}/account/password`, payload)
      .then((res) => {
        setVisible(true);
        setMessage('Password aggiornata!');
        if (!visible) {
          setTimeout(() => {
            setVisible(false);
            navigate("/");
          }, 3000);
        }
      }).catch((error) => {

        setError(error.response.data.errorMessage);
        if (error) {
          setTimeout(() => {
            setError('');
          }, 3000);
        }
      })
  }

  const isFormValid =
    form.password.trim() !== '' &&
    form.confirmPassword.trim() !== '' &&
    !errors.password.error &&
    !errors.confirmPassword.error;

  //const [iconName, setIconName] = useState(eyeIcon);
  const [textboxType, setTextboxType] = useState<any>({
    password: {
      type: 'password',
      icon: eyeIcon
    },
    confirmPassword: {
      type: 'password',
      icon: eyeIcon
    }
  });
  const handleClick = (fieldName: any) => {
    // Ottieni lo stato attuale del campo
    const currentType = textboxType[fieldName].type;
    const currentIcon = textboxType[fieldName].icon;

    // Calcola i nuovi valori
    const newType = currentType === 'password' ? 'text' : 'password';
    const newIcon = currentIcon === eyeIcon ? eyeSlashIcon : eyeIcon;

    // Aggiorna lo stato, mantenendo gli altri campi (e le loro proprietà) inalterati
    setTextboxType((prevState: any) => ({
      ...prevState, // Mantiene lo stato dell'altro campo (e sue proprietà)
      [fieldName]: { // Aggiorna solo il campo specificato
        type: newType,
        icon: newIcon
      }
    }));
  };



  return (
    <div className={error == '' ? styles.form_resetPassword : styles.tokenExpired}>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 0,
          position: "absolute",
          alignItems: "flex-start",
          flexWrap: "wrap-reverse",
        }}
      >
        <Fade enter={true} exit={true}>
          {visible && (
            <Notification
              type={{ style: "success", icon: true }}
              closable={true}
              onClose={() => setVisible(false)}
            >
              <span>{message}</span>
            </Notification>
          )}
          {/*{error && (
            <Notification
              type={{ style: "error", icon: true }}
              closable={true}
              onClose={() => setError(false)}
            >
              <span>{error}</span>
            </Notification>
          )}*/}
        </Fade>
      </NotificationGroup>

      <img src={logo} className={styles.logo} />
      <h1 className={styles.textLocator}>{localizationService.toLanguageString('title', 'NOT FOUND')}</h1>
      <img src={imageLogo} style={{ margin: '10px auto', textAlign: 'center', display: 'block', width: '200px' }} />

      {loading ? loadingPanel

        : error != '' ?
          <b style={{ color: 'red' }}>{localizationService.toLanguageString('token_expired', 'NOT FOUND')}</b>
          :
          <>
            <h3>{localizationService.toLanguageString('login.resetPassword', 'NOT FOUND')}</h3>
            <div style={{ borderBottom: '1px solid #ccc', width: '100%', margin: '8px 0' }}></div>

            <form>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{localizationService.toLanguageString('login.newPassword', 'NOT FOUND')}</label>
                <div className="fieldWithErrorBubble">
                  <TextBox
                    style={{ padding: '0.5rem' }}
                    name="password"
                    value={form.password}
                    onChange={onUpdateField}
                    type={textboxType.password.type}
                    onBlur={onBlurFieldResetPassword}
                    suffix={() => (
                      <Button svgIcon={textboxType.password.icon} onClick={() => handleClick('password')} fillMode="flat" />
                    )}
                  />
                  {getFieldError('password') ? (
                    <span className={styles.inputErrorOverlay} role="alert" aria-live="polite">
                      {getFieldError('password')}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{localizationService.toLanguageString('login.repeatPassword', 'NOT FOUND')}</label>
                <div className="fieldWithErrorBubble">
                  <TextBox
                    style={{ padding: '0.5rem' }}
                    name="confirmPassword"
                    value={form.confirmPassword}
                    onChange={onUpdateField}
                    type={textboxType.confirmPassword.type}
                    onBlur={onBlurFieldResetPassword}
                    suffix={() => (
                      <Button svgIcon={textboxType.confirmPassword.icon} onClick={() => handleClick('confirmPassword')} fillMode="flat" />
                    )}
                  />
                  {getFieldError('confirmPassword') ? (
                    <span className={styles.inputErrorOverlay} role="alert" aria-live="polite">
                      {getFieldError('confirmPassword')}
                    </span>
                  ) : null}
                </div>
              </div>
            </form>

            <button
              className={styles.resetPasswordBtn}
              disabled={!isFormValid}
              onClick={() => resetPassword()}
            >
              {localizationService.toLanguageString('login.resetPassword', 'NOT FOUND')}
            </button>
          </>
      }

    </div>
  )
}